import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import Misc, { CopyToClipboardButton, MONTHS, oh } from '../base/components/Misc';
import PropControl from '../base/components/PropControl';
import SubCard from '../base/components/SubCard';
import KStatus from '../base/data/KStatus';
import List from '../base/data/List';
import { getDataList } from '../base/plumbing/Crud';
import { copyTextToClipboard, yessy, isoDate, str } from '../base/utils/miscutils';
import ServerIO from '../plumbing/ServerIO';
import ListLoad, {SimplePrettyListItem} from '../base/components/ListLoad';
import SimpleTable from '../base/components/SimpleTable';
import DataStore, { getDataPath } from '../base/plumbing/DataStore';
import NewChartWidget from '../base/components/NewChartWidget';
import { getDataLogData, pivotDataLogToRows } from '../base/plumbing/DataLog';
import PropControlDataItem from '../base/components/propcontrols/PropControlDataItem';
import SearchQuery from '../base/searchquery';
import { ABC } from './CarbonPage';
import C from '../C';
import PropControlPeriod from '../base/components/propcontrols/PropControlPeriod';
import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc';
import PropControlMoney from '../base/components/propcontrols/PropControlMoney';
import Money from '../base/data/Money';
import LinkOut from '../base/components/LinkOut';
import { dateStr } from '../base/utils/date-utils';

/**
 * See CarbonPage which is a bit similar but for Green Media
 */
function T4GPage({}) {
    let start = DataStore.getUrlValue("start");
	let end = DataStore.getUrlValue("end");

    let sq = SearchQuery.setProp(sq, "evt", "tabadview");
    const cid = DataStore.getUrlValue('cid');
	if (cid) {
		sq = SearchQuery.setProp(sq, 'cid', cid);
	}
    if ( ! DataStore.getUrlValue('incGL')) {
        sq = SearchQuery.and(sq, "-(user:/.*@good-loop.com@email/)");
    }


    // chart: tabs over time    
    let pvTimeData = getDataLogData({name:"TimeData", dataspace:"gl", q:sq.query, start, end, breakdowns: ["time"] });
	let timeLabels = [];
	let timeData = [];
	if (pvTimeData.value) {
		let buckets = pvTimeData.value.by_time.buckets;
		buckets.forEach((b, i) => {
			let d = dateStr(new Date(b.key));
			timeLabels.push(d);
			timeData.push(b.count);
		});
	}
	let chartData = { labels: timeLabels, datasets: [{ data: timeData }] };
	const options = {};

    // table by charity
    let breakdowns = ["cid"];
    let pvData = getDataLogData({ dataspace:"gl", q:sq.query, start, end, breakdowns });
    let dataRows = pvData.value && pivotDataLogToRows(pvData.value, breakdowns[0]);
	let columns = [
        { Header: "Charity", accessor: 'cid', Cell: v => <ABC id={v} type={C.TYPES.NGO} />, total: false },
		{ Header: "Ad Views", accessor: 'count' },
        { Header: "Active Users", accessor: 'user' }
    ];

    // users
    let pvNumUsers = getDataLogData({dataspace:"gl", q:sq.query, start, end, breakdowns:['cid{"user":"cardinality"}']});
    let numUsersRows = pvNumUsers.value && pivotDataLogToRows(pvNumUsers.value, "cid");
    // merge the data
    if (dataRows && numUsersRows) {
        dataRows.forEach(row => {
            let rcid = row.cid;
            let nur = numUsersRows.find(row2 => row2.cid === rcid);
            if (nur) row.user = nur.user;
        });
    }

	return <>
		<h1>(draft) Tabs for Good (T4G) Reporting Tools</h1>
        
        <SubCard title="Filters">
            <PropControlPeriod />
            <PropControlDataItem label="Charity" itemType="NGO" prop="cid" />
            <PropControl type="toggle" prop="incGL" dflt={false} label="Include Good-Loop users" />
        </SubCard>

        <h4>Tab Ad Views</h4>
        <NewChartWidget title="Tab Ad Views" data={chartData} options={options} height={null} width={null} legend={false} />

        {yessy(dataRows) && 
            <SimpleTable rowsPerPage={10} data={dataRows} columns={columns} hasCsv="top" addTotalRow tableName={"tabadview-" + start + "-" + end} />
        }

        <MoneyRaised start={start} end={end} cid={cid} />

        <EnterAdMoney />
	</>;
}


function EnterAdMoney() {
    const type = "ImpactDebit";
    let path = ["widget","EnterAdMoney"];
    let ipath = path.concat("impact");
    let form = DataStore.getValue(path) || DataStore.setValue(path, {});
    form.id = "T4GMoney"+form.end;
    form.product="T4G";
    if (form.cpm) {
        if ( ! form.impact) form.impact = {};
        form.impact.amountRate = Money.mul(form.cpm, 0.001);
    }
    if (form.end) {
        DataStore.setValue(getDataPath({type, id:form.id, status:KStatus.DRAFT}), form, false);
    }
    
    return <SubCard title="(for Dan) Enter Ad Money We've Raised via T4G as an ImpactDebit">
        <PropControlPeriod path={path} options="month/year" />
        <PropControl type="Money" prop="amount" path={ipath} label />
        <PropControlDataItem label prop="vertiser" path={path} itemType={C.TYPES.Advertiser} dflt={GOOGLE_ADSENSE_ID} />
        <PropControl type="Money" 
            prop="cpm" path={path} label="CPM" help="As reported by Google AdSense" />
        <small>Amount Rate: {form.impact?.amountRate && <Misc.Money amount={form.impact?.amountRate} />}</small>
    
        {form.id && <SavePublishDeleteEtc position="relative" path={path} 
            type={type} id={form.id} autoSave={false} autoPublish={false} />}
    </SubCard>;
}

/**
 * Our Portal Advertiser ID for Google AdSense
 */
const GOOGLE_ADSENSE_ID = "3691243924";

function MoneyRaised({start, end}) {
    // debits for Google AdSence
    let q = "vertiser:"+GOOGLE_ADSENSE_ID;
    let pvDebits = getDataList({q, type:"ImpactDebit",status:KStatus.PUBLISHED});
    let debits = DataStore.resolveDataList(List.hits(pvDebits.value)); 

    // // debits for T4G charities
    // let pvCharityDebits = getDataList({q:"product:T4G impact.charity:unset", type:"ImpactDebit",status:KStatus.PUBLISHED});
    // let t4gDebitRows = [];
    // if (pvCharityDebits.value) {
    //     t4gDebitRows = List.hits(pvCharityDebits.value).map(imp => {
    //         return {id:imp.id, charity:imp.impact?.charity, start:imp.start, end:imp.end, amount: imp.impact?.amount, cpm: imp.impact?.amountRate};
    //     });
    // }
    const columns = [
        "id",
        {Header:"Start", accessor:"start", type:"date", total:false},
        {Header:"End", accessor:"end", type:"date", total:false},
        // {Header:"Charity", accessor:imp => imp.impact?.charity, total:false},
        {Header:"Amount", accessor:imp => imp.impact?.amount, type:"Money"},
        {Header:"CPM", accessor:imp => Money.mul(imp.impact?.amountRate,1000), total:false}
    ];

    return <SubCard title="Money Raised">

        <SimpleTable data={debits} columns={columns} addTotalRow />

        See <LinkOut href="https://docs.google.com/spreadsheets/d/1Lx11tpWOd5hGWgiBSaarOcNTyPenqjoZ6CvKnpII41U/edit#gid=1456692216">Tabs for Good T4G User tracker + Payments from Google Adsense</LinkOut>
        </SubCard>;
}

export default T4GPage;
